/*
  industrialkonzept Next: FAQ page (sections/ik-faq.liquid), 2026-09-25
  - an address with a question (#how-long-does-delivery-take) opens that question; opening one writes its address
  - search: filters the questions as you type (all words must appear, accents ignored), hides empty topics
  - topic chips: mark the topic in view
  Without this script every question is still there and opens with a click; only the search field stays hidden.
*/
(() => {
  const root = document.querySelector('[data-ikp-faq]');
  if (!root || root.__ikp) return;
  root.__ikp = true;

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const items = [...root.querySelectorAll('.ikp-qa')];
  const groups = [...root.querySelectorAll('.ikp-faq__group')];
  const chips = [...root.querySelectorAll('[data-ikp-topic]')];
  const box = root.querySelector('[data-ikp-search-box]');
  const input = root.querySelector('[data-ikp-search]');
  const status = root.querySelector('[data-ikp-status]');
  const empty = root.querySelector('[data-ikp-empty]');
  const norm = (s) => (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');

  /* Addresses */
  const openFromHash = () => {
    let id = '';
    try {
      id = decodeURIComponent(location.hash.slice(1));
    } catch (e) {
      return;
    }
    const el = id && document.getElementById(id);
    if (!el || !el.classList.contains('ikp-qa')) return;
    el.open = true;
    el.scrollIntoView({ block: 'start', behavior: reduced ? 'auto' : 'smooth' });
    const summary = el.querySelector('summary');
    if (summary) summary.focus({ preventScroll: true });
  };
  window.addEventListener('hashchange', openFromHash);
  openFromHash();

  items.forEach((item) => {
    item.addEventListener('toggle', () => {
      if (item.open && location.hash.slice(1) !== item.id) history.replaceState(null, '', '#' + item.id);
    });
  });

  /* Search */
  if (box && input) {
    box.hidden = false;
    const texts = items.map((item) => norm(item.textContent));
    const say = (n) => (root.getAttribute(n === 1 ? 'data-one' : 'data-other') || '').replace('#', n);
    const run = () => {
      const words = norm(input.value).split(/\s+/).filter(Boolean);
      let hits = 0;
      items.forEach((item, i) => {
        const hit = words.every((w) => texts[i].includes(w));
        item.hidden = !hit;
        if (hit) hits += 1;
      });
      groups.forEach((group) => {
        group.hidden = !group.querySelector('.ikp-qa:not([hidden])');
      });
      chips.forEach((chip) => {
        const group = document.getElementById('faq-' + chip.getAttribute('data-ikp-topic'));
        chip.hidden = !!(group && group.hidden);
      });
      if (status) status.textContent = words.length ? say(hits) : '';
      if (empty) empty.hidden = hits > 0;
    };
    input.addEventListener('input', run);
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && input.value) {
        input.value = '';
        run();
      }
    });
  }

  /* Topic in view */
  if ('IntersectionObserver' in window && chips.length) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const topic = entry.target.id.replace('faq-', '');
          chips.forEach((chip) => {
            const on = chip.getAttribute('data-ikp-topic') === topic;
            chip.classList.toggle('is-active', on);
            if (on) chip.setAttribute('aria-current', 'true');
            else chip.removeAttribute('aria-current');
          });
        });
      },
      { rootMargin: '-30% 0px -60% 0px' }
    );
    groups.forEach((group) => io.observe(group));
  }
})();
